import React from 'react';
import { CLOSE_ICON, SEARCH_ICON } from './constants';

const SearchContentToggleIcon = ({ onClick, useCloseIcon }) => (
  <svg
    className="search-content--expanded__icon"
    viewBox="0 0 20 20"
    onClick={onClick}
    data-testid={useCloseIcon ? 'search-content-icon-close' : 'search-content-icon'}>
    <path fillRule="evenodd" clipRule="evenodd" d={useCloseIcon ? CLOSE_ICON : SEARCH_ICON} />
  </svg>
);

export default SearchContentToggleIcon;
